import Pagination from '../../../../container/pagination/Pagination';

import {
  type ChangeBrandPageAtomPromise,
  lastPageLoadedIncludingLoadMoreAtom,
} from '@vs-shop/engine/atom/brand/pagination';
import type { HydraViewExtended } from '@vs-shop/schemas/openapi/hydraView';

type Props = {
  hydraViewExtended: HydraViewExtended;
  changePage: ChangeBrandPageAtomPromise;
  scrollToBrandsGrid: () => void;
  canonicalUrl: string;
};

export default function BrandsPagination({
  hydraViewExtended,
  changePage,
  scrollToBrandsGrid,
  canonicalUrl,
}: Props) {
  return (
    <Pagination
      hydraViewExtended={hydraViewExtended}
      changePage={changePage}
      scrollToGrid={scrollToBrandsGrid}
      baseUrl={canonicalUrl}
      lastPageLoadedIncludingLoadMoreAtom={lastPageLoadedIncludingLoadMoreAtom}
    />
  );
}
